import React, {
    useEffect,
    useState,
    useCallback
} from "react";
import Swal from "sweetalert2";

import {

    Card,
    Row,
    Col,
    Typography,
    Tag,
    Button,
    Space,
    Input,
    Empty,
    Spin,
    message,
    Segmented,
    Divider

} from "antd";


import {

    CheckOutlined,
    ClockCircleOutlined,
    DeleteOutlined,
    SearchOutlined,
    UndoOutlined

} from "@ant-design/icons";


import dayjs from "dayjs";


import api from "../../api/api";


import {
    useAcademicYear
} from "../../AcademicYearContext";



const {
    Title,
    Text
} = Typography;



const COLORS = {

    black:"#111111",

    orange:"#f97316",

    camel:"#c19a6b",

    light:"#f8f1e7",

    white:"#ffffff"

};





const TodoList = ()=>{


    const {
        selectedYear
    } = useAcademicYear();




    const [
        todos,
        setTodos
    ] = useState([]);




    const [
        loading,
        setLoading
    ] = useState(false);




    const [
        filter,
        setFilter
    ] = useState("all");




    const [
        search,
        setSearch
    ] = useState("");







    /*
        Fetch Todos
        showLoader = true
        only on first page load

        showLoader = false
        background refresh
    */


    const fetchTodos =
    useCallback(
    async(
        showLoader=true
    )=>{


        if(!selectedYear){
            return;
        }



        try{


            if(showLoader){
                setLoading(true);
            }



            let url =
            `/todos/?academic_year=${selectedYear.id}`;



            if(filter !== "all"){

                url +=
                `&status=${filter}`;

            }



            if(search){

                url +=
                `&search=${search}`;

            }





            const response =
            await api.get(url);



            setTodos(

                response.data.results
                ||
                response.data

            );



        }
        catch(error){


            console.error(error);


            if(showLoader){

                message.error(
                    "Unable to load todo list"
                );

            }


        }
        finally{


            if(showLoader){

                setLoading(false);

            }


        }



    },
    [
        selectedYear,
        filter,
        search
    ]);







    /*
        Initial Load
    */


    useEffect(()=>{


        fetchTodos(true);


    },[
        fetchTodos
    ]);








    /*
        Auto Refresh Every 3 Seconds
        No WebSocket
    */


    useEffect(()=>{


        if(!selectedYear){
            return;
        }




        const interval =

        setInterval(()=>{


            fetchTodos(false);


        },3000);





        return ()=>{


            clearInterval(
                interval
            );


        };



    },[
        selectedYear,
        fetchTodos
    ]);

    const updateStatus =
    async(todo)=>{


        try{


            if(todo.status === "pending"){


                await api.patch(
                    `/todos/${todo.id}/complete/`
                );


                message.success(
                    "Task completed"
                );


            }
            else{


                await api.patch(
                    `/todos/${todo.id}/pending/`
                );


                message.info(
                    "Task moved back to pending"
                );


            }



            /*
              Instant refresh without spinner
            */

            fetchTodos(false);



        }
        catch(error){


            console.error(error);


            message.error(
                "Failed updating task"
            );


        }


    };




const deleteTodo =
async(id)=>{


    const result = await Swal.fire({

        title:
        "Delete this task?",


        text:
        "You won't see this list again after deleting it.",


        icon:
        "warning",


        showCancelButton:
        true,


        confirmButtonColor:
        COLORS.orange,


        cancelButtonColor:
        "#777",


        confirmButtonText:
        "Yes, delete it",


        cancelButtonText:
        "Cancel"


    });



    if(!result.isConfirmed){

        return;

    }



    try{


        await api.delete(
            `/todos/${id}/`
        );



        setTodos(
            prev =>
            prev.filter(
                item =>
                item.id !== id
            )
        );



        Swal.fire({

            title:
            "Deleted!",


            text:
            "Your task has been removed.",


            icon:
            "success",


            timer:
            1500,


            showConfirmButton:
            false

        });



    }
    catch(error){


        console.error(error);



        Swal.fire({

            title:
            "Delete Failed",


            text:
            "Unable to delete this task.",


            icon:
            "error"

        });


    }


};



    return (

        <div

            style={{

                height:"100%"

            }}

        >



        <Card

            bordered={false}

            style={{

                borderRadius:20,

                height:"100%",

                background:COLORS.white,

                boxShadow:
                "0 10px 30px rgba(0,0,0,.12)"

            }}

        >





        <Row

            justify="space-between"

            align="middle"

            gutter={[16,16]}

        >



        <Col>


        <Title

            level={4}

            style={{

                margin:0,

                color:COLORS.black

            }}

        >

            My Todo List

        </Title>



        <Text type="secondary">

            Manage your daily activities

        </Text>


        </Col>





        <Col>


        <Segmented


            value={filter}


            onChange={
                value =>
                setFilter(value)
            }


            options={[

                {
                    label:"All",
                    value:"all"
                },

                {
                    label:"Pending",
                    value:"pending"
                },

                {
                    label:"Completed",
                    value:"completed"
                }

            ]}


        />


        </Col>



        </Row>








        <Divider/>







        <Input


            size="large"


            placeholder=
            "Search task..."


            prefix={
                <SearchOutlined/>
            }


            value={search}


            onChange={
                e =>
                setSearch(
                    e.target.value
                )
            }



            style={{

                marginBottom:15

            }}


        />








        {
        loading ?



        <div

            style={{

                textAlign:"center",

                padding:40

            }}

        >

            <Spin size="large"/>

        </div>



        :



        todos.length === 0 ?



        <Empty

            description=
            "No todo task found"

        />



        :



        <div

            style={{

                maxHeight:520,

                overflowY:"auto",

                paddingRight:5

            }}

        >




        <Row

            gutter={[12,12]}

        >



        {

        todos.map(

            todo => (



            <Col

                xs={24}

                key={todo.id}

            >



            <Card


                hoverable


                size="small"


                style={{


                    borderRadius:16,


                    border:

                    todo.status === "completed"

                    ?

                    "2px solid #52c41a"

                    :

                    `2px solid ${COLORS.orange}`


                }}


            >




            <Space

                direction="vertical"

                size={10}

                style={{

                    width:"100%"

                }}

            >






            <Row

                justify="space-between"

                align="middle"

            >


            <Col>


            <Title

                level={5}

                style={{

                    margin:0

                }}

            >

                {todo.title}


            </Title>


            </Col>



            <Col>


            <Tag


                color={

                    todo.status === "completed"

                    ?

                    "green"

                    :

                    "orange"

                }



                icon={

                    todo.status === "completed"

                    ?

                    <CheckOutlined/>

                    :

                    <ClockCircleOutlined/>

                }


            >

                {todo.status}


            </Tag>


            </Col>



            </Row>






            <Text>


            {

            todo.description

            ||

            "No description"

            }


            </Text>







            <Text type="secondary">


            Reminder:

            {" "}

            {
            todo.reminder_date

            ?

            dayjs(
                todo.reminder_date
            )
            .format(
                "DD MMM YYYY"
            )

            :

            "No date"

            }


            </Text>







            <Button


                block


                icon={

                    todo.status === "completed"

                    ?

                    <UndoOutlined/>

                    :

                    <CheckOutlined/>

                }


                onClick={()=>
                    updateStatus(todo)
                }


                style={{


                    background:

                    todo.status === "completed"

                    ?

                    COLORS.camel

                    :

                    COLORS.orange,


                    color:"white",

                    border:"none"


                }}


            >


            {

            todo.status === "completed"

            ?

            "Mark Pending"

            :

            "Complete"

            }


            </Button>







            <Button


                danger


                block


                icon={
                    <DeleteOutlined/>
                }


                onClick={()=>
                    deleteTodo(todo.id)
                }


            >

                Delete


            </Button>






            </Space>





            </Card>





            </Col>


            )

        )


        }





        </Row>




        </div>


        }




        </Card>


        </div>

    );



};


export default TodoList;



